import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    position: "absolute",
    minHeight: "80vh",
    maxWidth: "40vw",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "0rem",
    marginTop: "4%",
    left: 0,
    right: 0,
    borderRadius: "1rem",
  },
  cardTitulo: {
    fontWeight: "bold",
  },
  root: {
    flexGrow: 1,
  },
  scrollContainer: {
    height: "80vh",
    overflow: "auto",
    overflowX: "hidden",
  },
  scroll: {
    position: "relative",
    width: "100%",

    height: "80%",
  }
}));

export default useStyles;
